import {
    // Constants
    SETTINGS_CHANGED,
    LOCALE_CHANGED,
    PROCESS_CHANGED,
    SERVER_PROFILES_CHANGED,
    ACTIVE_SERVER_CHANGED,
    SERVERLIST_CHANGED,

    // Actions
    setDownloadEverything,
    setRunClientsWithLogging,
    setRunClientsWithDx9,
    setShouldMinimizeToTray,
    setLocale,
    setTestServers,
    setActiveServer,

    // Selectors
    getActiveServer,
    getActiveServerId,
    getActiveServerName,
    getActiveProgress,
    getActivePlayable,
    getActiveProcess,
    getActiveRunningProcesses,
    getActiveEveClientVersion,
    getLauncherBackendVersion,
    getServer,
    getServers,
    getActiveServerProfiles,
    getBackendReadyState,
    // Settings related
    getSimplifiedServers,
    getDownloadEverything,
    getRunClientsWithLogging,
    getRunClientsWithDx9,
    getShouldMinimizeToTray,
    getLocale,
    getDefaultServer,
    getTestServers,
    getLauncherType,
    getDeviceId,
} from './data'

// Reducer is exposed so that we can hook up the state
export { default as backendReducer } from './data/reducer'

// Middleware is exposed so that we can hook it up to the store creation
export { default as middleware } from './middleware'

// Constants are exposed as a way for settings to send out information
// Way for the feauture to inform the surroundings of something that has happened
export const constants = {
    SETTINGS_CHANGED, // LauncherCommandMiddleware
    LOCALE_CHANGED, // FeatureMiddleware
    PROCESS_CHANGED, // LaunchProgressBar feature middleware
    SERVER_PROFILES_CHANGED, // UserProfileMiddleware
    ACTIVE_SERVER_CHANGED, // Used by NotifierMiddleware
    SERVERLIST_CHANGED, // Used by SyncMiddleware
}

// Actions are exposed as a way for the feature to recieve information
// The surrounding can send in data using these actions
export const actions = {
    setDownloadEverything,
    setRunClientsWithLogging,
    setRunClientsWithDx9,
    setShouldMinimizeToTray,
    setLocale,
    setTestServers,
    setActiveServer, // Used by the ServerMenu feature
}

// Selectors are exposed as a way for the surrounding to query the
// state from the feature
export const selectors = {
    getActiveServer, // Used by Launch-Frame container
    getActiveServerId, // Used by probably everyone..., for now only by LaunchProgressBar feature
    getActiveServerName, // Used by the LoadingBar feature
    getActiveProgress, // Used by the LoadingBar feature
    getActivePlayable, // Used by User & UserList containers
    isPlaying: getActiveProcess, // Used by User
    getActiveRunningProcesses, // Used by LaunchProgressBar feature middleware & UserList container
    getActiveEveClientVersion, // Used by LoadingBar feature
    getLauncherBackendVersion, // Used by LoadingBar feature
    getServer, // Used by ServerMenu feature
    getServers, // Used by ServerMenu feature
    getActiveServerProfiles, // Used by ProfileSelector
    isBackendReady: getBackendReadyState, // Used by App container
    getLauncherType, // Used by the SideMenu container
    // Settings related
    getSimplifiedServers, // Used by the Settings feature
    getDownloadEverything, // Used by the Settings feature
    getRunClientsWithLogging, // Used by the Settings feature
    getRunClientsWithDx9, // Used by the Settings feature
    getShouldMinimizeToTray, // Used by the Settings feature
    getLocale, // Used by the Settings feature and Toaster feature
    getDefaultServer,
    getTestServers, // Used by the Settings feature
    getDeviceId,
}



// WEBPACK FOOTER //
// ./src/features/Backend/exports.js